export const SOURCES = {
  crmsHome: {
    label: 'CRMS Home',
    url: 'https://crms.leanderisd.org',
  },
  crmsCampusInfo: {
    label: 'CRMS Campus Info',
    url: 'https://crms.leanderisd.org/campus_information',
  },
  lisdCalendar2627: {
    label: 'LISD 2026-27 Calendar Approval',
    url: 'https://news.leanderisd.org/mark-your-calendar-2026-27-academic-calendar-approved-2027-28-drafted/',
    note: 'Board approved Feb 19, 2026',
  },
  bellSchedulePdf: {
    label: 'CRMS Bell Schedule PDF',
    url: 'https://drive.google.com/file/d/1UIMEWn6JWI9n7k5CKfXOO8l4a7zqeU1M',
    note: 'Direct download — exact period times in PDF',
  },
  hb1481: {
    label: 'HB 1481 — LISD Device Rules',
    url: 'https://news.leanderisd.org/state-law-sets-new-rules-for-student-device-use/',
  },
  smartTagPortal: {
    label: 'SMART Tag Parent Portal',
    url: 'https://parent.smart-tag.net/@leanderisd',
  },
  busInfo: {
    label: 'LISD Transportation: Bus Information',
    url: 'https://www.leanderisd.org/transportation_businformation/',
  },
  childNutrition: {
    label: 'LISD Child Nutrition Services',
    url: 'https://www.leanderisd.org/childnutritionservices/',
  },
  mLisd: {
    label: 'LISD mLISD Program',
    url: 'https://www.leanderisd.org/mlisd/',
  },
  hac: {
    label: 'Home Access Center',
    url: 'https://www.leanderisd.org/homeaccesscenter/',
  },
  humanSexuality: {
    label: 'CRMS Human Sexuality 7-8',
    url: 'https://crms.leanderisd.org/parent_resources/human-sexuality-7th-8th',
  },
  bullyingPrevention: {
    label: 'LISD Bullying Prevention',
    url: 'https://www.leanderisd.org/bullyingprevention/',
  },
  anonymousAlerts: {
    label: 'Anonymous Alerts (Leander ISD)',
    url: 'https://www.anonymousalerts.com/leanderisd/',
    note: 'Login: leanderisd / Password: leanderisd. Monitored 7 AM–5 PM school days.',
  },
  questGt: {
    label: 'LISD QUEST/GT Identification',
    url: 'https://www.leanderisd.org/quest_screeningidentificationprocess/',
  },
  avid: {
    label: 'LISD AVID Program',
    url: 'https://www.leanderisd.org/avid/',
  },
  advancedAcademicsMs: {
    label: 'LISD Advanced Academics — Middle School',
    url: 'https://www.leanderisd.org/advancedacademics_middleschool/',
  },
  crmsClubs: {
    label: 'CRMS Clubs & Organizations',
    url: 'https://sites.google.com/leanderisd.org/crmsclubs/clubs-home',
  },
  crmsAthletics: {
    label: 'CRMS Athletics',
    url: 'https://sites.google.com/leanderisd.org/crms-athletics/home',
  },
  crmsCounseling: {
    label: 'CRMS Counseling',
    url: 'https://sites.google.com/leanderisd.org/crmscounseling/home',
  },
  crmsLibrary: {
    label: 'CRMS Library',
    url: 'https://sites.google.com/leanderisd.org/crms-library/',
  },
  crmsAttendance: {
    label: 'CRMS Attendance',
    url: 'https://sites.google.com/leanderisd.org/crmsattendance/home',
  },
  crmsRegistrar: {
    label: 'CRMS Registrar',
    url: 'https://sites.google.com/leanderisd.org/crmsregistrar/home',
  },
  courseCatalog2627: {
    label: 'LISD MS Course Catalog 2026-27',
    url: 'https://docs.google.com/document/d/1Rv58Kj1MQdJmuBlYNXiW6sZyc1ObfQuOo2Zen7qFjao/view',
  },
  studentHandbook: {
    label: 'LISD Student & Parent Handbook 2025-26',
    url: 'https://www.leanderisd.org/handbooks',
  },
  ptaCrms: {
    label: 'CRMS PTA',
    url: 'https://canyonridgemspta.memberhub.com',
  },
  athleticBoosters: {
    label: 'CRMS Athletic Booster Club',
    url: 'https://crmsbooster.ch2v.com',
  },
};
